import React from 'react';
import PlayIcon from './PlayIcon';

const DownloadButton = () => (
  <a href="https://play.google.com/store/apps/details?id=com.sequspace.sequpay" className="btn-play" target="_blank" rel="noopener noreferrer">
    <PlayIcon />
    <div className="btn-play-lbl"><small>GET IT ON</small><strong>Google Play</strong></div>
  </a>
);

export default DownloadButton;
